import amplitude from 'amplitude-js';
import Cookies from 'js-cookie';
import getRuntimeEnv from './env';

export const logToAmplitude = (eventName: string, data?: any): void => {
  if (getRuntimeEnv().REACT_APP_AMPLITUDE_KEY) {
    const userData = Cookies.get('amplitude_user');

    if (userData) {
      const userDataObject: any = JSON.parse(userData);
      amplitude.getInstance().setUserProperties({
        ...userDataObject,
      });
    }

    amplitude.getInstance().logEvent(eventName, data);
  }
};

export interface IUserAmplitudeSettings {
  user_has_visited_video_page: boolean;
  professional_role: string | null;
  working_location: string | null;
  label_or_department: string | null;
}

export const logLoginEvent = (
  userSettings?: IUserAmplitudeSettings,
  oktaUserObject?: any
): void => {
  if (getRuntimeEnv().REACT_APP_AMPLITUDE_KEY) {
    const userCookie = Cookies.get('user_v2');
    let user: any;

    if (userCookie) {
      user = JSON.parse(userCookie);
    }
    amplitude.getInstance().setUserProperties({
      ...userSettings,
      ...oktaUserObject,
    });
    amplitude.getInstance().logEvent('Opus Logged In User', user);

    Cookies.set('InitAmplitude', '0');
    Cookies.set('amplitude_user', JSON.stringify(userSettings));
  }
};
